import * as React from "react"
import { Action, IOWidget, mk_widget } from "widgets-for-react"
import { CMSState, Url } from "../../../../cms/blocks/types.gen"
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen"
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { toRelativeUrl } from "../../../../../helpers";
import { PublicSite_CustomPageData } from "../../../application.mod";

export type LinkBlockProps = {
  index: number
  title: string
  intro?: string
  primary_button?: ButtonData
  secondary_button?: ButtonData
  items: LinkProps[]
  useSVGIcons: boolean
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type LinkProps = {
  key?: string
  title: string
  url: Url
  text?: string
  is_link_external: boolean
  target?: "_blank" | "_self"
}

export function LinkBlock<customBlockData, extra_images> (
  props: LinkBlockProps,
  options?: {
    key?: string
  }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData> , Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData> ) =>
    mk_widget({
      run: _ => (
        <section id={`io-${options && options.key ? options.key : props.index}`}
          className="block block--link-list"
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className="block__inner container--xs grid--block">
            {(props.title || props.intro) && (
              <header className="block__header">
                {props.title && (<h2 className="block__title typo--3xl">{props.title}</h2>)}
                {props.intro && (<p className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }}></p>)}
              </header>
            )}

            <div className="block__content">
              <ul className="block__list list-iconed list-iconed--arrow">
                {props.items.map((l, index) => (
                  l.title && l.url && (
                    <li>
                      {link(linkWrapper({title:l.title, url:l.url}),
                        {
                          classname: ''
                        },
                        (<>
                          {l.title}
                        </>)
                      )}
                    </li>
                  )
                ))}
              </ul>
            </div>
            
            {(props.primary_button || props.secondary_button) && (
              <footer className="block__footer">
                {props.primary_button && (
                    link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                      { classname: 'button button--primary' },
                      props.primary_button.text
                    )
                )}
                {props.secondary_button && (
                    link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'button button--secondary' },
                      props.secondary_button.text
                    )
                )}
              </footer>
            )}
          </div>
        </section>
      ),
    })
}
